module.exports = __webpack_public_path__ + "img/emptycart.663599f8.png";